import classNames from 'classnames';
import classes from './Tab.module.scss';
import { NoStyleButton } from '../icon-button/IconButton';

function AppTab({ className, children, onClick, isActive, shallTruncate, ...props }) {
    return (
        <NoStyleButton
            className={classNames(
                classes.tab,
                shallTruncate && classes.tabShallTruncate,
                isActive && classes.tabActive,
                className
            )}
            onClick={onClick}
            {...props}
        >
            {children}
        </NoStyleButton>
    );
}
export default AppTab;
